import Axios from 'axios';
import AxiosMiddleware from '../libs/AxiosMiddleware';
import Config from '../config';
import OPCODE from '../libs/OPCODE';
import router from '../router';

export const TYPES = {
  UPDATE_BROADCASTS: 'UPDATE_BROADCASTS',
};

const state = {
  broadcasts: [],
};

const mutations = {
  [TYPES.UPDATE_BROADCASTS](state, broadcasts) {
    state.broadcasts = broadcasts;
  },
};

const actions = {
  async refreshBroadcast({ commit }) {
    try {
      const { data } = await Axios.get(`${Config.hostname}/v1/broadcast/`, {
        withCredentials: true,
      });

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            commit(TYPES.UPDATE_BROADCASTS, data.broadcasts);
            break;
        }
      }
    } catch {
      Config.alert.mixin({
        type: 'error',
        title: '인터넷 상태를 확인해주세요.',
      });
    }
  },
  async applyBroadcast(_, post) {
    try {
      const {
        data,
      } = await Axios.post(`${Config.hostname}/v1/broadcast/create`, post, {
        withCredentials: true,
      });

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            Config.alert.mixin({
              type: 'success',
              title: '성공적으로 글을 작성했습니다.',
            });
            router.push('/broadcast');
            break;
          case OPCODE.INVALID:
            Config.alert.mixin({
              type: 'error',
              title: '제목과 내용을 모두 입력하여 주세요.',
            });
            break;
        }
      }
    } catch (err) {
      Config.alert.mixin({
        type: 'error',
        title: '인터넷 상태를 확인해주세요.',
      });
    }
  },
};

const getters = {};

export default { state, mutations, getters, actions };
